import { render, staticRenderFns } from "./rateSunyicaozuobiao.vue?vue&type=template&id=65b16525"
import script from "./rateSunyicaozuobiao.vue?vue&type=script&lang=js"
export * from "./rateSunyicaozuobiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports